import React from "react";
import { Divider } from "@mui/material";
import { FinancialRowConfig } from "../../types";

type RenderRowParams = {
  row: FinancialRowConfig;
  index: number;
  total: number;
  currency: string | undefined;
};

type Props = {
  rows: FinancialRowConfig[];
  currency?: string;
  renderRow: (_params: RenderRowParams) => React.ReactNode;
};

export const FinancialRowList = React.memo(
  ({ rows, currency, renderRow }: Props) => {
    const shouldRenderDividerAbove = (row: FinancialRowConfig) => {
      if (row.key === "profit") return true;
      if (row.key === "buyerRefund") return true;
      return false;
    };

    return (
      <>
        {rows.map((row, index) => (
          <React.Fragment key={row.key}>
            {shouldRenderDividerAbove(row) && <Divider sx={{ my: 1 }} />}

            {renderRow({
              row,
              index,
              total: rows.length,
              currency,
            })}
          </React.Fragment>
        ))}
      </>
    );
  },
);
